"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    props: {
        block: {
            type: Object,
            default: null,
        },
        class: {
            type: [Object, String],
            default: null,
        },
    },
    computed: {
        itemClass: function () {
            return [this.class];
        },
        style: function () {
            var _a, _b;
            var style = {};
            if ((_a = this.block.fields) === null || _a === void 0 ? void 0 : _a.MarginTop) {
                style.marginTop = this.block.fields.MarginTop;
            }
            if ((_b = this.block.fields) === null || _b === void 0 ? void 0 : _b.MarginBottom) {
                style.marginBottom = this.block.fields.MarginBottom;
            }
            return style;
        },
        componentKey: function () {
            return "block-".concat(this.block.template.replace(/.([A-Z])/g, function (m) { return "".concat(m[0], "-").concat(m[1]); })).toLowerCase();
        },
    },
    template: '<section :style="style" :class="itemClass" v-if="block" :data-litium-block-id="block.systemId"><suspense><component :is="componentKey" :block="block" /></suspense></section>',
};
//# sourceMappingURL=block-container.js.map